import styled from 'styled-components'

export const InnerPanelStyled = styled.div.attrs((props) => ({}))`
    border: 1px solid ${(props) => props.theme.colors.accentColorMuted} !important;
`
export const InnerFieldStyled = styled.div.attrs((props) => ({}))``
